/**
 * Test IDs for QA automation.
 */
export const testIds = {
  loadSplittingModalAddSplitPoint: "load-splitting-modal-add-split-point",
  loadSplittingModalCancel: "load-splitting-modal-cancel",
  loadSplittingModalSplitOrder: "load-splitting-modal-split-order",
  loadSplittingModalDelete: "load-splitting-modal-delete",
  loadSplittingModalSplitQuantity: "load-splitting-modal-split-quantity",
} as const;
